import React from 'react';
import { Grid } from '@mui/material';

import NewPage from '../components/NewPage';
import BotStatusContainer from '../containers/BotStatusContainer';

const BotPage = () => {
  return (
    <NewPage title="봇 관리">
      <Grid item xs={12}>
        <BotStatusContainer />
      </Grid>
    </NewPage>
  );
};

export default BotPage;
